$(document).ready(function(){
//     if (window.innerWidth < 768) {
//     setTimeout(function() {
//         var elements = document.querySelectorAll('.boost-pfs-filter-option-content-inner');
// elements.forEach(function(element) {
//   element.setAttribute('data-simplebar', '');
// });
//     console.log("yes");
// }, 2000);
//     }
  var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
})